<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        class="block text-xs text-ontick-carbon-900 dark:text-gray-300"
        >{{ label }}</label
      >
      <span v-if="optional" class="text-sm text-gray-400">{{ optional }}</span>
    </div>
    <div class="a relative mt-1 rounded-md shadow-sm">
      <div
        v-if="trailing"
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <span class="text-gray-400 sm:text-sm">{{ trailing }}</span>
      </div>
      <div
        class="pointer-events-none absolute top-1.5 left-2 h-full w-full overflow-hidden"
      >
        <span v-if="!value" class="text-sm text-gray-500">
          {{ placeholder }}
        </span>
      </div>
      <select
        @change="updateValue"
        @blur="$emit('blur')"
        :disabled="disabled"
        :value="value"
        :class="[
          error
            ? 'border border-ontick-red-500'
            : 'border-ontick-steel-300 dark:border-ontick-carbon-500',
          trailing ? 'px-8 ' : 'px-2',
          bg,
          noBorder ? 'border-none' : '',
          shadow,
          disabled
            ? 'text-gray-400'
            : 'text-ontick-carbon-900 dark:text-gray-300',
        ]"
        class="focus:outline-none block w-full appearance-none rounded-lg py-2 ring-ontick-blue-600 transition-all duration-300 focus:ring-1 sm:text-sm"
      >
        <option
          v-for="(option, index) in options"
          :value="option.value"
          :key="index"
        >
          {{ option.label }}
        </option>
      </select>

      <div
        v-show="error"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <!-- Heroicon name: exclamation-circle -->
        <span class="text-ontick-red-500" v-html="$icons.error"></span>
      </div>
      <div
        v-show="error"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      ></div>
    </div>
    <p v-show="error" class="mt-1 text-xs text-ontick-red-500">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    options: {
      type: Array,
    },
    value: String,
    noBorder: {
      type: Boolean,
    },
    shadow: {
      type: String,
      default: "shadow-lg",
    },
    bg: {
      type: String,
      default: "bg-ontick-carbon-500",
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    optional: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trailing: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
      validator: (val) => {
        return (
          ["url", "text", "password", "email", "search", "number"].indexOf(
            val
          ) !== -1
        );
      },
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
<style></style>
